import { Vue, Component } from 'vue-property-decorator'
@Component
export default class pxOrderConfirm extends Vue {
    confirmObg: any = {} // 接口返回的基础数据
    isReduction = true;
    address = '' // 地址
    goodsList: any = [] // 商品集合
    totalCost = 0  //  订单总金额
    payWay: any = [] // 支付方式集合
    payWayIndex = 0 //  支付方式当前项下标
    maxYjb: number = 0 // 最大可使用邮金币数量
    isAllUse = false; // 是否使用全部的邮金币
    crossShopFlag:Number=0;//参与平台满减传1
    yjb: number|string = '' // 使用的邮金币
    selectedCouponCode = ''
    comboFlag = false // 是否套餐
    checkDetilFlag = false // 套餐明细
    cutMoney:Number=0;//平台满减金额
    presellInfo: any = {
        deposit: 0,
        balancePayment: 0,
        discountAmount: 0,
        payStartTime: 0,
        payEndTime: 0
    }
    pxSuiteDetail: any = {pxSuiteDetail4PushTagDtos:[]} //套餐信息
    constructor() {
        super();

    }
    apis = window.apis

    created() {
        console.log(this.$route.params.itemNumMap);
        console.log(this.$route.params.activityMap);

        this.getGoodsInfo()
    }

    // 使用全部的邮金币
    setAllYjb(){
        this.isAllUse = !this.isAllUse

        if(this.isAllUse){
            this.yjb = this.maxYjb
        }else{
            this.yjb = ''
        }
    }

    // 邮金币数字发生变化
    setYjb(){
        this.calculate()
    }

    // 选择支付方式
    chiocePayWay(index: number) {
        this.payWayIndex = index;
        this.calculate();
    }

    // 使用优惠券
    selectedCoupon(item: any, index: number) {
        item.isCouponShow = false
        item.couponIndex = index

        if (index === -1) {
            item.couponText = ''
            item.couponAmount = 0
            item.costs = 0
        } else {
            item.couponText = item.couponInfo[index].code
            item.couponText = item.couponInfo[index].costs
            item.couponAmount = item.couponInfo[index].amount

        }
        this.calculate()
        this.$forceUpdate()
    }

    // 显示隐藏优惠券列表
    chioceCkick(item: any) {
        item.isCouponShow = !item.isCouponShow
        this.$forceUpdate()
    }

    // 计算总价
    calculate() {
        let couponAmountAll: number = 0
        let yjbNum:number = this.yjb ? Number(this.yjb) : 0
        if(this.cutMoney>0&&(this.payWay[this.payWayIndex].key=='online'||this.payWay[this.payWayIndex].key=='yck')){//平台满减金额  && 在线支付 || 预存款支付
            this.crossShopFlag=1;
        }else{
            this.crossShopFlag=0;
        }
        this.goodsList.forEach((ele: any, ind: number) => {
            couponAmountAll += ele.couponAmount;
            if(ele.costs==1){//平台类优惠券   不和平台满减同时参与  
                this.crossShopFlag=0;
            }
        })

        this.totalCost = this.confirmObg.totalPrice - couponAmountAll - yjbNum
    }

    // 商品信息
    getGoodsInfo() {
        console.log(this.$route.params.itemNumMap);
        console.log(this.$route.params.activityMap);

        this.fetch({
            url: this.apis.getConfrimOrder,
            data: {
                itemNumMap: this.$route.params.itemNumMap,
                // itemNumMap: {800000440201:1},//团购
                // activityMap: this.$route.params.activityMap||{800000440201:3423},//团购
                // itemNumMap: {800001989901:1},//预售
                // activityMap: this.$route.params.activityMap||{800001989901:100641},//预售
                // itemNumMap: {800000323401:1},//金融
                activityMap: this.$route.params.activityMap||{},//活动
                groupFlag: this.$route.params.groupFlag||false, // 团购
                presellFlag: this.$route.params.presellFlag||false, // 预售
                comboFlag: this.$route.params.comboFlag||false, // 是不是套餐
                financeFlag:this.$route.params.financeFlag||false,//是否金融专享
                accountPeriodFlag: this.$route.params.accountPeriodFlag||false, // 账期支付
                channel: 'YZGPC'
            }
        }).then((res: any) => {
            const data: any = res
            console.log(data)
            this.confirmObg = data
            this.totalCost = data.totalPrice  // 总价
            this.maxYjb = data.itemYjb > data.pointNum ? data.pointNum : data.itemYjb // 最大可使用邮金币个数
            this.payWay = data.merPayType // 支付方式集合
            this.address = data.userAddressInfo.username + data.userAddressInfo.provinceName + data.userAddressInfo.cityName + data.userAddressInfo.cityName + data.userAddressInfo.areaName + data.userAddressInfo.addressDetail +'，'+ data.userAddressInfo.phone
            this.goodsList = data.merItemInfo
            this.comboFlag = data.comboFlag

            // 整合优惠券以及其他需要的信息
            this.goodsList.forEach((ele: any, ind: number) => {
                ele.couponInfo = data.couponInfo.couponInfo[ele.merchantId] // 商家优惠券信息
                ele.isCouponShow = false // 是否显示优惠券列表
                ele.couponIndex = -1 // 选中的优惠券
                ele.couponText = "" // 显示的优惠券文字
                ele.couponAmount = 0 // 使用的优惠券金额
                ele.buyNote = "" // 留言
                if(data.firsrActInfo && ele.merchantId == data.firsrActInfo.merId){//首单立减信息
                    ele.firstCutMoney = data.firsrActInfo.cutMoney;
                    ele.merTotalPrice -= ele.firstCutMoney;
                    this.totalCost -= ele.firstCutMoney;
                }
            })

            if (data.comboFlag) {//套餐信息字段
                this.pxSuiteDetail = JSON.parse(data.merItemInfo[0].itemList[0].itemTags)[4040]
                console.log(this.pxSuiteDetail)
                this.goodsList[0].itemTotalPrice += this.pxSuiteDetail.discountsPrice;
                this.goodsList[0].disAmount += this.pxSuiteDetail.discountsPrice;
                this.totalCost = this.goodsList[0].merTotalPrice;
                console.log(this.goodsList);
            }
            if (data.presellFlag) {//预售信息字段
                this.presellInfo = data.presellInfo
                this.totalCost = this.presellInfo.deposit;
            }
            if (data.groupFlag) {//团购信息字段
                this.goodsList[0].disAmount += data.groupInfo.discountAmount;
                this.goodsList[0].merTotalPrice -= this.goodsList[0].disAmount;
                this.totalCost = this.goodsList[0].merTotalPrice;
            }
            if (data.financeFlag) {//金融专享专区

            }
            if(data.crossShops){//平台满减
                this.crossShopFlag = 1;
                for (let cro = 0; cro < data.crossShops.length; cro++) {
                    const cross = data.crossShops[cro];
                    this.cutMoney += cross.cutMoney;
                }
            }
        })
    }
    comfirm() {
        let userAddressInfo: any = this.confirmObg.userAddressInfo // 地址信息
        let buyNoteMap: any = {} // 买家留言 key-商家id value-留言信息
        let couponMap: any = {} // 创建订单提交的优惠券集合 key=商家id value=优惠券code_优惠券金额
        let couponTypeMap:any = {} // 优惠券类型map key=商家id value=可用券类型
        let categoryMap:any = {} // 商品分类信息 key-商家id value-商品分类信息json
        let accountMap:any = {} //账期商家map key=商家id value=1

        this.goodsList.forEach((ele: any, ind: number) => {
            if(this.$route.params.accountPeriodFlag){
                accountMap[ele.merchantId] = 1
            }
            buyNoteMap[ele.merchantId] = ele.buyNote

            if (ele.couponIndex > -1) {
                let coup = ele.couponInfo[ele.couponIndex]
                couponMap[ele.merchantId] = coup.code + "_" + coup.amount
                couponTypeMap[ele.merchantId] = this.confirmObg.couponInfo.merchantCouponMap[ele.merchantId]
                categoryMap[ele.merchantId] = this.confirmObg.couponInfo.categoryMap[ele.merchantId]
            }
        })
        let data={
            cartType: this.cartType,
            username: userAddressInfo.username,
            provinceCode: userAddressInfo.provinceCode,
            cityCode: userAddressInfo.cityCode,
            areaCode: userAddressInfo.areaCode,
            townCode: userAddressInfo.townCode,
            provinceName: userAddressInfo.provinceName,
            cityName: userAddressInfo.cityName,
            areaName: userAddressInfo.areaName,
            townName: userAddressInfo.townName,
            addressDetail: userAddressInfo.addressDetail,
            mobilePhone: userAddressInfo.phone,
            orgCode: userAddressInfo.orgCode,
            payType: this.payWay[this.payWayIndex].value,
            itemNumMap: this.$route.params.itemNumMap,
            activityMap:this.$route.params.activityMap,
            couponMap: couponMap,//创建订单提交的优惠券集合 key=商家id value=优惠券code_优惠券金额	
            couponTypeMap: couponTypeMap,//优惠券类型map key=商家id value=可用券类型
            categoryMap: categoryMap,//商品分类信息 key-商家id value-商品分类信息json
            buyNoteMap: buyNoteMap,
            userYzb: this.confirmObg.pointNum, // 用户可用邮金币
            maxPoint: this.confirmObg.itemYjb, // 商品最大可用邮金币值
            usrPayedPoint: this.yjb, // 用户使用邮金币数量
            presellPhone:'',//预售发送短信手机号 非预售可不传
            isGroupPurchase:this.$route.params.groupFlag||false,//团购订单   Boolean
            isPresellOrder:this.$route.params.presellFlag||false,//预售订单  Boolean
            isFinance:false,//内部价标识  非内部价可不传   Boolean
            accountMap:accountMap,//账期商家map key=商家id value=1
            deviceId:'',//	设备id	
            systemVersion:'',//系统版本
            systemModel:window.navigator.userAgent,//	型号
            carSaleFlag:'',//	是否车销
            replenishmentOrder:'',//补货单订单标识
            seckillFlag:false,//是否秒杀  Boolean
            pointNumMap:{},//金币信息 key-商家id value-最大金币数
            crossShopFlag:this.crossShopFlag,//参与平台满减活动传1
        }

        console.log(data);
        
        this.fetch({ //接口wiki地址 http://wiki.uletm.com/pages/viewpage.action?pageId=36478237
            url: this.apis.createOrder,
            data: data
        }).then((res: any) => {
            window.location.href = '//wholesale'+ window.domain +'/fxPayOrder/payment/paymentReq.do?orderIds=' + res;//下单成功跳转的页面
        })
    }
    checkDetil() {
        this.checkDetilFlag = !this.checkDetilFlag
    }
}
